<template>
  <div style="border: 1px solid #ccc">
    <Toolbar
      :default-config="{
        excludeKeys: ['fullScreen', 'uploadImage', 'uploadVideo']
      }"
      :editor="editor"
      style="border-bottom: 1px solid #ccc"
    ></Toolbar>
    <Editor
      :default-config="{
        placeholder: '请输入内容...'
      }"
      @onChange="onChange"
      @onCreated="onCreated"
      style="height: 480px; overflow-y: hidden"
    ></Editor>
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'

export default {
  name: 'RichText',
  components: {
    Editor,
    Toolbar
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    }
  },
  data () {
    return {
      editor: null
    }
  },
  methods: {
    onChange (editor) {
      this.$emit('input', editor.getHtml())
    },
    onCreated (editor) {
      this.editor = Object.seal(editor)
      if (this.value) this.editor.setHtml(this.value)
      this.readOnly ? this.editor.disable() : this.editor.enable()
    }
  }
}
</script>
